'use client'

// FIX: Next.js 15.5.6 scroll restoration bug con Turbopack
// Bug: installHook.js genera warnings excesivos cuando detecta position: fixed/sticky
// Solución: Deshabilitar scroll restoration automático de Next.js y dejar que el navegador lo maneje

import { useEffect } from 'react'

export function ScrollRestorationFix() {
  useEffect(() => {
    // Deshabilitar el scroll restoration automático de Next.js
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }

    // Suprimir warnings específicos de Next.js 15.5.6
    const originalWarn = console.warn
    console.warn = function (...args: unknown[]) {
      const message = String(args[0])

      // Filtrar SOLO los warnings del bug de scroll restoration
      const isScrollWarning =
        message.includes('Skipping auto-scroll behavior') ||
        message.includes('position: sticky') ||
        message.includes('position: fixed')

      if (!isScrollWarning) {
        originalWarn.apply(console, args)
      }
    }

    return () => {
      console.warn = originalWarn
    }
  }, [])

  return null
}
